var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRoleMngMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3366 17.7256H20.3401C20.4235 17.7256 20.4917 17.6574 20.4917 17.574V16.5126C20.4917 16.4292 20.4235 16.361 20.3401 16.361H16.995L17.8896 15.222C17.9102 15.1954 17.9215 15.1627 17.9218 15.1291C17.9218 15.0457 17.8535 14.9775 17.7701 14.9775H16.3942C16.3013 14.9775 16.2141 15.0211 16.1554 15.0931L14.8571 16.7439C14.7738 16.85 14.7283 16.9827 14.7283 17.1191C14.7302 17.4546 15.0012 17.7256 15.3366 17.7256ZM19.8852 18.9386H14.8818C14.7984 18.9386 14.7302 19.0068 14.7302 19.0902V20.1515C14.7302 20.2349 14.7984 20.3031 14.8818 20.3031H18.2269L17.3323 21.4422C17.3117 21.4688 17.3004 21.5014 17.3001 21.535C17.3001 21.6184 17.3684 21.6867 17.4517 21.6867H18.8277C18.9206 21.6867 19.0077 21.6431 19.0665 21.5711L20.3647 19.9203C20.4481 19.8142 20.4936 19.6815 20.4936 19.545C20.4917 19.2096 20.2207 18.9386 19.8852 18.9386Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2643 12.2827C13.996 12.2827 15.3997 10.879 15.3997 9.14732C15.3997 7.41568 13.996 6.0119 12.2643 6.0119C10.5327 6.0119 9.12891 7.41568 9.12891 9.14732C9.12891 10.879 10.5327 12.2827 12.2643 12.2827ZM12.2643 13.7827C14.8244 13.7827 16.8997 11.7074 16.8997 9.14732C16.8997 6.58725 14.8244 4.5119 12.2643 4.5119C9.70425 4.5119 7.62891 6.58725 7.62891 9.14732C7.62891 11.7074 9.70425 13.7827 12.2643 13.7827Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1282 13.7853C8.72305 13.7853 5.85034 16.827 5.85034 20.7239C5.85034 21.1381 5.51456 21.4739 5.10034 21.4739C4.68613 21.4739 4.35034 21.1381 4.35034 20.7239C4.35034 16.1283 7.77061 12.2853 12.1282 12.2853C12.5424 12.2853 12.8782 12.6211 12.8782 13.0353C12.8782 13.4496 12.5424 13.7853 12.1282 13.7853Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoleMngMenuIcon);
export default __webpack_public_path__ + "static/media/user-role-mng-menu-icon.4324f132348ffbea931e87e0c07636b0.svg";
export { ForwardRef as ReactComponent };